module.exports = __webpack_public_path__ + "img/en.70694939.png";